/**
 * Nhận diện lỗi "không tìm thấy bản ghi" từ tRPC (code NOT_FOUND / HTTP 404) hoặc REST.
 * Dùng để: không retry vô ích khi người dùng gõ sai id trên URL, và hiển thị trang 404
 * thay vì báo lỗi kết nối.
 */
export function isNotFoundError(error: unknown): boolean {
  const e = error as any;
  if (!e) return false;
  const code = e.data?.code ?? e.shape?.data?.code ?? e.code;
  const status = e.data?.httpStatus ?? e.shape?.data?.httpStatus ?? e.status ?? e.response?.status;
  return code === 'NOT_FOUND' || status === 404;
}

/** Quy tắc retry mặc định: không retry lỗi 404, các lỗi khác thử lại 1 lần */
export function retryUnlessNotFound(failureCount: number, error: unknown): boolean {
  return !isNotFoundError(error) && failureCount < 1;
}
